import React, { useRef, useContext, Fragment } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tools from "./JNSTools";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { CredsContext, HelpModeContext } from "./Contexts";
import DashboardPanelHeader from "./DashboardPanelHeader";
import "./styles/DashboardProjectMetrics.css";
import "./styles/normalize.css";

function DashboardProjectMetrics(props) {
  const projectObject = useRef(
    JSON.parse(sessionStorage.getItem("projectObject")),
  );
  const creds = useContext(CredsContext).creds;
  const helpMode = useContext(HelpModeContext).mode;
  const showBilling =
    projectObject.current.oada_project_show_billing__c == 1 ? true : false;

  const metrics = Tools.calculateProjectMetrics(projectObject.current, creds);

  const moneyConfig = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  const dataArray = [
    {
      title: "Actual",
      hours: metrics.actualHours,
      cost: moneyConfig.format(metrics.actualMoney),
    },
    {
      title: "+ ETC",
      hours: metrics.estimateToCompletion,
      cost: moneyConfig.format(metrics.etcMoney),
    },
    {
      title: "= EAC",
      hours: metrics.estimateAtCompletion,
      cost: moneyConfig.format(metrics.eacMoney),
    },
    {
      title: "vs Budget",
      hours: metrics.budgetHours,
      cost: moneyConfig.format(metrics.budgetMoney),
    },
    {
      title: "Over/Under",
      hours:
        Math.round((metrics.budgetHours - metrics.estimateAtCompletion) * 100) /
        100,
      cost: moneyConfig.format(metrics.budgetMoney - metrics.eacMoney),
    },
  ];

  const headerTemplate = (event) => {
    return <span className="dashHeaderRow">{event.headerText}</span>;
  };

  const title = "Project Metrics";
  return (
    <Fragment>
      <Box
        height="12%"
        className="dashTableTitleBar"
        sx={{ cursor: helpMode ? "help" : "default" }}
        id="__dashboardProjectMetrics_grid"
      >
        <DashboardPanelHeader
          panelLocked={props.panelLocked}
          title={title}
          removePanel={props.removePanel}
          panelId={props.panelId}
        />
      </Box>

      <Box
        height="85%"
        id="__dashboardProjectMetrics_grid"
        sx={{
          overflow: "auto",
          verticalAlign: "middle",
          border: "solid 2px",
          padding: "0px 4px 4px 4px",
          borderRadius: "0px 0px 6px 6px",
          backgroundColor: "white",
          cursor: helpMode ? "help" : "default",
        }}
      >
        <GridComponent className="gridWithSmallHeader" dataSource={dataArray}>
          <ColumnsDirective>
            <ColumnDirective
              field="title"
              headerText=""
              textAlign="Right"
              customAttributes={{ class: "metricTitle" }}
            />
            <ColumnDirective
              field="hours"
              headerText="Hours"
              headerTemplate={headerTemplate}
              textAlign={showBilling ? "Right" : "Center"}
              customAttributes={{ class: "metricHours" }}
            />
            <ColumnDirective
              field="cost"
              headerText="Billed"
              headerTemplate={headerTemplate}
              textAlign="Right"
              customAttributes={{ class: "metricMoney" }}
              visible={showBilling}
            />
          </ColumnsDirective>
        </GridComponent>
      </Box>
    </Fragment>
  );
}

export default DashboardProjectMetrics;

DashboardProjectMetrics.propTypes = {
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
};
